import React from 'react';
import { StyledSwitch } from './styles/ReadOnlySwitchStyles';

interface IProps {
  label: string;
  checked: boolean;
}

const ReadOnlySwitch: React.FC<IProps> = (props) => {
  const { label, checked } = props;
  return <StyledSwitch label={label} checked={checked} reversed readOnly withoutBorder onChange={() => {}} />;
};

export default ReadOnlySwitch;
